/* import javascript lib */
import $ from 'jquery'
window.$ = window.jQuery = $;

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
